export const IDENTITY_STATE = {
  NOT_CREATED: 'notCreated',
  PENDING: 'pending',
  FAILURE: 'failure',
  SUCCESS: 'success',
};
